// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": () => import("C:\\Users\\Nico\\Documents\\business\\wipek\\lck\\repo\\prepaid-card-registration-page\\node_modules\\gatsby-plugin-offline\\app-shell.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-404-js": () => import("C:\\Users\\Nico\\Documents\\business\\wipek\\lck\\repo\\prepaid-card-registration-page\\src\\pages\\404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("C:\\Users\\Nico\\Documents\\business\\wipek\\lck\\repo\\prepaid-card-registration-page\\src\\pages\\index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

exports.data = () => import("C:\\Users\\Nico\\Documents\\business\\wipek\\lck\\repo\\prepaid-card-registration-page\\.cache\\data.json")

